import { getMerchants } from '@nemuru-eng/js-api-client';

import { fetchForDataGrid } from '@/utils/fetchForDataGrid';

export function useMerchantsList() {
  const fetchMerchantList = async (query) => {
    const customFilters = query?.filters;
    return fetchForDataGrid(getMerchants, { ...query, filters: customFilters });
  };

  return {
    fetchMerchantList,
  };
}
